import type { ScratchRegisterInput } from '@/lib/api/scratch-campaigns-public.service'
import { onlyDigits } from '@/components/CpfCnpjInput/utils'
import { normalizeFullName } from './normalize-full-name'
import { onlyPhoneDigits } from './mask-brazilian-phone'
import type { ScratchRegisterFormValues } from './validate-register-fields'

export function buildScratchRegisterPayload(
  values: ScratchRegisterFormValues
): ScratchRegisterInput {
  return {
    name: normalizeFullName(values.name),
    email: values.email.trim().toLowerCase(),
    phone: onlyPhoneDigits(values.phone),
    document: onlyDigits(values.document),
  }
}
